import { withFieldHint } from "@/src/components/HighOrderComponents";
import { AutoNumberField } from "./AutoNumberField";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import { useHandleApiCall } from "@/src/components/pages/StepPage/components/apiCalls/useHandleApiCall";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import {apiCallsModalStore} from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import {ApiCallModalType} from "@/src/components/pages/StepPage/components/apiCalls/types";
import {ModalErrorTypes} from "@/src/shared/const";

const AutoNumberFieldWithHint = withFieldHint(AutoNumberField);

export function AutoNumberInput(props: any) {
  const { hint, name, apiCalls } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const {
    control,
    formState: { isDirty },
    trigger,
    getValues,
  } = form;

  const debouncedUpdateField = useFieldDebouncedCallback(name);

  const [isLoading, setIsLoading] = useState(false);

  const { handleApiCall } = useHandleApiCall();

  const handleApiCalls = async () => {
    const formValues = getValues();
    const isValid = await trigger(name);

    if (isValid && isDirty && apiCalls?.length) {
      setIsLoading(true);
      // await Promise.allSettled(
      //   apiCalls.map(({ params }) => handleApiCall(formValues, params)),
      // );

      handleApiCall(formValues, apiCalls[0].params)
        ?.catch((e) => {
            if (e?.response?.data?.error && e?.response?.data?.error === ModalErrorTypes.NOT_ALLOWED) {
                apiCallsModalStore
                    .getState()
                    .open(ApiCallModalType.AUTO_SEARCH_FORBIDDEN, {
                        plateNumber: formValues["plateNumber"] || "",
                    })
            }
          console.log(e);
        })
        ?.finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <AutoNumberFieldWithHint
        {...props}
        placeholder="AA 0000 AA"
        hints={hints}
        control={control}
        name={name}
        disabled={isLoading || props.disabled}
        loading={isLoading}
        onChange={(e) => {
          if (!e?.currentTarget?.closest('[role="dialog"]')) {
            debouncedUpdateField(e.target.value);
          }
        }}
        onBlur={handleApiCalls}
      />
    </>
  );
}
